var global = require('../internals/global');

module.exports = global;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/path.js